import React from 'react'
import { Icon } from 'semantic-ui-react'
import AbsoluteDiv from '@bsd/dashboard-toolkit/components/AbsoluteDiv'

export default () =>
  <AbsoluteDiv style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: '3em',
    color: '#CCC',
  }}>
    <Icon name='clipboard'/>
    <div>Выберите категорию</div>
  </AbsoluteDiv>